// extracted by mini-css-extract-plugin
export default {"header":"Faq_header__MMe0Q","mainSection":"Faq_mainSection__dUV2K","paragraph":"Faq_paragraph__CBDkH","plusSign":"Faq_plusSign__CF4-O"};